const state = () => ({
  /**
   * @type {null | number}
   */
  childReg: null,
})

const mutations = {
  SET_CHILD_REG(state, payload) {
    state.childReg = payload
  },
}

export default {
  state,
  mutations,
  namespaced: true,
}
